import EtgAccess from "../../features/etgAccess/etgAccess";
import { CallbackPage } from "../../features/etgAccess/CallbackPage";
import App from "../../App";
import PatientInfo from "../../features/patientInfo/patientInfo";
import TablesAndFigures from "../../features/tables-and-figures/tables-and-figures";
import { ModernHomePage } from "../LandingPage";
import ContactUs from "../../features/contact-us/ContactUs";
import Import from "../../features/importClassic/ImportClassic";
import GenAI from "../../features/genai/genai";
import MyCart from "../../features/subscription/myCart";
import Checkout from "../../features/subscription/checkout";
import AccountChangePassword from "../AppAccount/AccountChangePassword";
import CheckoutConfirmation from "../../features/subscription/checkoutConfirmation";
import UserConfirmation from "../../features/subscription/userConfirmation";
import XeroAuth from "../../features/subscription/payment/xeroAuth";
import XeroAuthResponse from "../../features/subscription/payment/xeroAuthResponse";
import UserProfile from "../../features/userProfile/userProfile";
import { useTransition, a } from "@react-spring/web";
import { Route, Routes, useLocation, Navigate } from "react-router-dom";
import CalculatorRouter from "../templates/CalculatorRouter";
import { useEffect, useRef } from "react";
import useAppModernisation from "../../hooks/useAppModernisation";
import { GuidelineTemplate } from "../Guideline/GuidelineTemplate";
import SearchRouter from "../../features/enhancedSearch/SearchRouter";
import SearchLandingPage from "../../features/appMode/SearchLandingPage";
import DrugLandingPage from "../../features/appMode/DrugLandingPage";
import AccountLandingPage from "../../features/appMode/AccountLandingPage";
import FavouritesPage from "../../features/appMode/FavouritesPage";
import AppSavedSearches from "../AppAccount/AppSavedSearches";
import DrugOverviewPage from "../../features/drugs/DrugOverviewPage";
import AboutUsAndLegal from "../AppAccount/AboutUsAndLegal";
import AccountSubscriptions from "../AppAccount/AccountSubscriptions";
import SalesforceAccountSubscriptions from "../AppAccount/SalesforceAccountSubscriptions";
import SiteLayout from "../Layout/SiteLayout";
import ModernGuidelineNav from "../../features/guideline/ModernGuidelineNav";
import ResourceRouter from "../templates/ResourceRouter";
import AppRouter from "../../features/topic/AppRouter";
import DrugOverviewAppPage from "../../features/appMode/DrugOverviewAppPage";
import GuidelinesPage from "../Guidelines/GuidelinesPage";
import ProtectedRoute from "../../features/login/ProtectedRoute";
import FAQPage from "../FAQ/FAQPage";
import SubscribePage from "../../features/login/SubscribePage";
import UpdatesPage from "../Updates/UpdatesPage";
import ManageAppUsers from "../AppAccount/ManageAppUsers";
import MondernImportPage from "../ModernImport/MondernImportPage";
import { TopicTeaserRedirect } from "../../features/topic/TopicTeaserRedirect";
import { SingleSignout } from "../../features/signout/SingleSignout";

const animateRoutes = ["/resources", "/calculator"];

const routes = [
  { path: "/assets", Component: EtgAccess },
  { path: "/etgAccess", Component: EtgAccess },
  { path: "/openathens-callback", Component: CallbackPage },
  { path: "/viewTopic", Component: AppRouter },
  { path: "/topicTeaser", Component: TopicTeaserRedirect },
  { path: "/quicklinks", Component: App },
  { path: "/searchAction", Component: SearchRouter },
  { path: "/app/searchLanding", Component: SearchLandingPage },
  { path: "/app/drugLanding", Component: DrugLandingPage },
  { path: "/app/accountLanding", Component: AccountLandingPage },
  { path: "/app/favourites", Component: FavouritesPage },
  { path: "/app/savedSearch", Component: AppSavedSearches },
  { path: "/app/aboutUsAndLegal", Component: AboutUsAndLegal },
  { path: "/app/manageUsers", Component: ManageAppUsers },
  { path: "/app/changePassword", Component: AccountChangePassword },
  { path: "/app/accountSubscription", Component: AccountSubscriptions },
  { path: "/app/accountSubscriptions", Component: SalesforceAccountSubscriptions },
  { path: "/patientInfo", Component: PatientInfo },
  { path: "/tables-and-figures", Component: TablesAndFigures },
  { path: "/calculator", Component: CalculatorRouter },
  { path: "/calculator/*", Component: CalculatorRouter },
  { path: "/resources/*", Component: ResourceRouter },
  { path: "/contact", Component: ContactUs },
  { path: "/import-classic", Component: Import },
  { path: "/genai", Component: GenAI },
  { path: "/myCart", Component: MyCart },
  { path: "/checkout", Component: Checkout },
  { path: "/checkout/orderConfirmation", Component: CheckoutConfirmation },
  { path: "/xeroAuth", Component: XeroAuth },
  { path: "/xeroAuth/response", Component: XeroAuthResponse },
  { path: "/showMyProfile", Component: UserProfile },
  { path: "/userConfirmation", Component: UserConfirmation },
  { path: "", Component: EtgAccess },
  { path: "/", Component: EtgAccess },
  { path: "/app/nav/*", Component: GuidelineTemplate },
  { path: "/app/drugOverview", Component: DrugOverviewAppPage },
  { path: "/drugOverview", Component: DrugOverviewPage },
  { path: "/guidelines/*", Component: ModernGuidelineNav },
  { path: "/guidelines", Component: GuidelinesPage },
  { path: "/faq", Component: FAQPage },
  { path: "/subscribe", Component: SubscribePage },
  { path: "/updates", Component: UpdatesPage },
  { path: "/import", Component: MondernImportPage },
  { path: "/signout", Component: SingleSignout },
  { path: "*", Component: () => <Navigate to="/" replace /> },
];

const getAnimationProps = (current, previous, initial) => {
  let direction = "";
  let curr = current === "/etgAccess/" ? "/" : current;
  let prev = previous === "/etgAccess/" ? "/" : previous;
  const currLength = getPathDepth(curr);
  const prevLength = getPathDepth(prev);

  const isHome = curr === "/" || curr === "/etgAccess/";
  const wasHome = prev === "/" || prev === "/etgAccess/";

  const currentIsAnimated = animateRoutes.some((path) => curr.startsWith(path)) || isHome;
  const prevIsAnimated = animateRoutes.some((path) => prev.startsWith(path)) || wasHome;

  if (currentIsAnimated && prevIsAnimated && current !== previous) {
    if (currLength > prevLength) {
      // Going from animated path to home
      direction = "forward";
    } else {
      // Going from home to animated path
      direction = "backward";
    }
    if (initial === true) {
      direction = "";
    }
  } else {
    direction = "";
  }

  switch (direction) {
    case "forward":
      return {
        from: { opacity: 0, transform: "translate3d(100%, 0, 0)" },
        enter: { opacity: 1, transform: "translate3d(0%, 0, 0)" },
        leave: {
          opacity: 0,
          transform: "translate3d(-100%, 0, 0)",
          position: "absolute",
        },
      };
    case "backward":
      return {
        from: { opacity: 0, transform: "translate3d(-100%, 0, 0)" },
        enter: { opacity: 1, transform: "translate3d(0%, 0, 0)" },
        leave: {
          opacity: 0,
          transform: "translate3d(100%, 0, 0)",
          position: "absolute",
        },
      };
    default:
      return {
        from: { opacity: 1 },
        enter: { opacity: 1 },
        leave: { opacity: 1 },
      };
  }
};

const getPathDepth = (pathname) => {
  if (pathname === "/") return 0;
  return pathname.split("/").length;
};

const AnimatedRoute = () => {
  const location = useLocation();
  const { isAppMode, isWebModernisationEnabled, isCalculatorsLegacyIntegration, isMobileView } =
    useAppModernisation();

  // Conditionally set the home page component based on modernisation flags
  const getHomeComponent = () => {
    // Use ModernHomePage only for web modernisation when NOT in app mode
    if (isWebModernisationEnabled && !isAppMode) {
      return ModernHomePage;
    }
    // Default to EtgAccess for legacy or app mode
    // if not login and b2c enabled, we will redirect to b2c login page
    return EtgAccess;
  };

  // Create routes with conditional home component
  const getRoutes = () => {
    const HomeComponent = getHomeComponent();
    return routes.map((route) => {
      // Replace the home routes with the conditional component
      if (route.path === "/" || route.path === "" || route.path === "/etgAccess") {
        return { ...route, Component: HomeComponent };
      }
      return route;
    });
  };

  const isInitialMount = useRef(true);
  const prevPathname = useRef("");
  useEffect(() => {
    prevPathname.current = location.pathname;
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
  }, [location.pathname]);

  useEffect(() => {
    if (isAppMode === true) {
      import("../../scss/appmode.scss");
    } else if (isWebModernisationEnabled === true) {
      import("../../scss/webmodern.scss");
    }
  }, [isAppMode, isWebModernisationEnabled]);

  const animationProps = getAnimationProps(
    location.pathname,
    prevPathname.current,
    isInitialMount.current,
  );

  const transitions = useTransition(location, animationProps);

  const publicPaths = [
    // "/",
    // "",
    "/subscribe",
    "/myCart",
    "/checkout",
    "/checkout/orderConfirmation",
    "/userConfirmation",
    "/xeroAuth",
    "/xeroAuth/response",
  ];

  const wrapWithAuth = (path, element) => {
    const isPublic = publicPaths.includes(path);
    return isPublic ? element : <ProtectedRoute>{element}</ProtectedRoute>;
  };

  const animatedRoutes = () => {
    const conditionalRoutes = getRoutes();
    return (
      <>
        {transitions((style, item) => {
          return (
            <a.div style={style} className={"animated-route"}>
              <SiteLayout>
                <Routes location={item}>
                  {conditionalRoutes.map(({ path, Component }, index) => (
                    <Route key={index} path={path} element={wrapWithAuth(path, <Component />)} />
                  ))}
                </Routes>
              </SiteLayout>
            </a.div>
          );
        })}
      </>
    );
  };

  const nonAnimatedRoutes = () => {
    const conditionalRoutes = getRoutes();
    // Drop 3: Use SiteLayout for all routes when web modernisation is enabled
    // EXCEPT calculator routes when using legacy integration (they handle their own navbar/header)
    const isCalculatorRoute = location.pathname.startsWith("/calculator");
    const shouldUseSiteLayout =
      isWebModernisationEnabled && !(isCalculatorRoute && isCalculatorsLegacyIntegration);

    if (shouldUseSiteLayout) {
      return (
        <SiteLayout>
          <Routes>
            {conditionalRoutes.map(({ path, Component }, index) => (
              <Route key={index} path={path} element={wrapWithAuth(path, <Component />)} />
            ))}
          </Routes>
        </SiteLayout>
      );
    }

    return (
      <Routes>
        {conditionalRoutes.map(({ path, Component }, index) => (
          <Route key={index} path={path} element={wrapWithAuth(path, <Component />)} />
        ))}
      </Routes>
    );
  };

  return isMobileView ? animatedRoutes() : nonAnimatedRoutes();
};

export default AnimatedRoute;
